import React, { useContext, useEffect } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

import { RestauInfoContext } from '../../home/RestauInfoContext.js';
import { useStyles } from '../../home/styles/useStyles';
import RegularHours from './RegularHours';
import { Hours, RegularHoursWrapper } from './HolidayStyles';

export default function DeliveryHours(props) {
    const { orderType } = props;
    const resauInfoContext = useContext(RestauInfoContext);
    const restauHook = resauInfoContext.restauHook;
    const [loaded, setLoaded] = React.useState(false);
    const [hours, setHours] = React.useState(undefined);
    const [specialHours, setSpecialHours] = React.useState(null);
    const classes = useStyles();

    const theme = useTheme();

    const isLarge = useMediaQuery(theme.breakpoints.up('md'), {
        noSsr: true,
    });

    async function updateRegularHoursConfig(config) {
        setLoaded(true);
        await saveRegularHours(restauHook.restauId, config);
        setHours(config);
        setLoaded(false);
    }

    async function saveHoursConfig(url, config) {
        const database = window.customerApp.database();
        const updates = { [url]: config };

        await database
            .ref()
            .update(updates)
            .then(function () {
                console.log('Hours updated successfully');
            })
            .catch(function (error) {
                console.log('Error while saving please try again');
                //Need to pop error someways
                console.log(error);
            });
    }

    async function saveRegularHours(restauId, config) {
        const url =
            'menus/' +
            restauId +
            (orderType === 'catering'
                ? '/details/cateringConfig/deliveryConfig/hours'
                : '/details/deliveryConfig/hours');
        saveHoursConfig(url, config);
    }

    function mergeConfigs(hoursConfig = {}, record = {}) {
        console.log(hoursConfig, record);
        let splHours = { ...hoursConfig }; //= hoursConfig ? hoursConfig : {};
        Object.keys(record).forEach((key, index) => {
            if (splHours[key]) {
                const holiday = record[key].holiday;
                splHours[key].holiday = holiday;
                if (holiday) {
                    delete splHours[key].hours;
                } else {
                    splHours[key].hours = [
                        ...(splHours[key].hours || []),
                        ...record[key].hours,
                    ];
                }
            } else {
                splHours[key] = record[key];
            }
        });
        return splHours;
    }

    async function loadData(restauHook) {
        //debugger;
        if (!window.customerApp.auth().currentUser) {
            //debugger;
            history.push('/login');
            return;
        }
        const token = await window.customerApp.auth().currentUser.getIdToken();

        let config = {
            headers: {
                token: token,
            },
        };
        console.log('Restau Hook from restaurant: ' + restauHook.restauId);
        const admin = window.customerApp.database();
        let menuRef = admin.ref(
            'menus/' +
                restauHook.restauId +
                (orderType === 'catering'
                    ? '/details/cateringConfig/deliveryConfig/hours'
                    : '/details/deliveryConfig/hours')
        );

        const menus = await menuRef
            .once('value')
            .then(function (snapshot) {
                let result = snapshot.val();
                //menuHook.setValue({menu:result});
                console.log('Hours::' + result);
                console.log(result);
                if (result) {
                    console.log('setting value');
                    setHours(result);
                }
                setLoaded(false);

                return result;
            })
            .catch(function (error) {
                setLoaded(false);
                console.log(error);
            });

        return;
    }
    useEffect(() => {
        setLoaded(true);
        loadData(restauHook);
    }, [restauHook.restauId]);

    return (
        <div>
            {loaded ? (
                <div>
                    <img
                        className={classes.loadingImage}
                        src="../../img/spinner.gif"
                    />
                </div>
            ) : (
                <Hours horizontalLayout={isLarge}>
                    <RegularHoursWrapper horizontalLayout={isLarge}>
                        <RegularHours
                            regularHours={hours || {}}
                            onUpdateConfig={updateRegularHoursConfig}
                        />
                    </RegularHoursWrapper>
                </Hours>
            )}
        </div>
    );
}
